/* eslint-disable camelcase */
import { apiContenedoresExportacionGet } from "../../api/descargas";
import { setOnClickEventDataTable } from "../../common/dataTables/utils";
import { dateFilterExportacionSelectChoices, dateFilterImportacionSelectChoices } from "./choices";
import {
    dataTablePedimentos,
    freezeAllDataTables,
    mostrarDetallePedimentoSeleccionado,
    onClickRowDataTablePedimento,
} from "./dataTables";
import { DescargaCommonGlobal } from "./descarga.global";
import { buildPedimentosExportacionValidos, isEmptyBusquedaPedimentos, verificaPedimentosIncompletos } from "./utils";
import { btnDescarga, resetView } from "./view";

/**
 * Busqueda de pedimentos de Exportación
 */
export const buscarPedimentos = async () => {
    resetView();
    freezeAllDataTables();

    const { value: filtroImportacion } = dateFilterImportacionSelectChoices.getValue();
    const { value: filtroExportacion } = dateFilterExportacionSelectChoices.getValue();

    let contenedores = [];

    contenedores = await apiContenedoresExportacionGet({
        fechaInicio: DescargaCommonGlobal.fechaInicio,
        fechaFin: DescargaCommonGlobal.fechaFin,
        filtroImportacion,
        filtroExportacion,
    });

    if (isEmptyBusquedaPedimentos(contenedores.length)) {
        freezeAllDataTables(false);
        return;
    }

    const pedimentosNoValidos = verificaPedimentosIncompletos(contenedores);
    contenedores = contenedores.filter(
        (contenedor) =>
            pedimentosNoValidos.findIndex((noValido) => noValido.pedimento_id === contenedor.pedimento_id) === -1,
        [],
    );

    DescargaCommonGlobal.pedimentosExportacionValidos = buildPedimentosExportacionValidos(contenedores);

    let pedimentosExportacionValidosDataTable = Object.keys(DescargaCommonGlobal.pedimentosExportacionValidos).map(
        (itm) => {
            const {
                pedimento_id,
                pedimento_formato,
                fecha,
                clave_documento,
            } = DescargaCommonGlobal.pedimentosExportacionValidos[itm];

            return {
                pedimento_id,
                pedimento_formato,
                fecha,
                clave_documento,
            };
        },
    );

    if (pedimentosExportacionValidosDataTable.length === 0) {
        freezeAllDataTables(false);
        return;
    }

    pedimentosExportacionValidosDataTable = pedimentosExportacionValidosDataTable.sort(
        (a, b) => new Date(a.fecha) - new Date(b.fecha),
    );

    dataTablePedimentos.options.data = pedimentosExportacionValidosDataTable;
    dataTablePedimentos.options.data[0]["item-selected"] = pedimentosExportacionValidosDataTable[0].pedimento_id;
    dataTablePedimentos.refresh();

    freezeAllDataTables(false);

    setOnClickEventDataTable(dataTablePedimentos, onClickRowDataTablePedimento);

    btnDescarga.disabled = false;

    mostrarDetallePedimentoSeleccionado(pedimentosExportacionValidosDataTable[0].pedimento_id);
};
